<template>
  <KeypadSetting
    :tag="tag"
    :prefix="cellPrefix"
    :reference="cellReference"
    :popoverTitle="popoverTitle"
    :popoverPrefix="popoverPrefix"
    :popoverReference="popoverReference"
    :selectedCells="selectedCells"
    :applyToAllColumnsEnabled="applyToAllColumnsEnabled"
    :getSubmitPopoverReferenceTag="getSubmitPopoverReferenceTag"
    :getSubmitValues="getSubmitValues"
    v-model:showingPopover="showingPopover"
    v-model:columnSelectionCode="columnSelectionCode"
  >
    <template #Checkboxes="{showingToggleRelativeValues}">
      <Checkbox v-if="showingToggleRelativeValues" v-model="store.showingRelativeValues" binary>
        Show relative values
      </Checkbox>
      <Checkbox v-if="showingFollowOption" v-model="popoverReferenceCode" binary>
        Follow supply setpoint
      </Checkbox>
      <slot name="BinSelectionInput"></slot>
    </template>
  </KeypadSetting>
</template>

<script setup>
import { computed } from "vue";
import { useKeypadReferenceOptions } from "./KeypadUtility";
import KeypadSetting from "./KeypadSetting.vue";
import store from "./store.js";

let props = defineProps([
  "tag",
  "prefix",
  "readOnly",
  "referenceSelector",
  "referenceOptions",
  "reconditioning",
  "disableInvertKey",
  "showingPopover",
  "popoverTitle",
  "selectedCells",
  "applyToAllColumnsEnabled",
  "columnSelectionCode",
  "validator"
]);

let showingPopover = defineModel("showingPopover");
let columnSelectionCode = defineModel("columnSelectionCode");

let showingFollowOption = computed(() => store.showAdvanced && props.referenceSelector);

let {
  cellPrefix,
  cellReference,
  popoverReferenceCode,
  popoverPrefix,
  popoverReference,
  getSubmitPopoverReferenceTag,
  getSubmitValues
}  = useKeypadReferenceOptions(props, showingPopover);
</script>